import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { authFetch } from '../services/authFetch';
import { ViewIcon, EditIcon, DeleteIcon } from '../components/IconButtons';
import AdminSidebar from '../components/AdminSidebar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/';

const AdminDaftarDoaPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPrayer, setSelectedPrayer] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState({
    category: 'doa harian',
    name: '',
    content: '',
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: 'success' });
  const [accordionState, setAccordionState] = useState({
    suratIjinOpen: false,
    laporanOpen: false,
    masterDataOpen: true // Open by default since we're in a master data page
  });
  const [user, setUser] = useState(null);


  useEffect(() => {
    const fetchPrayers = async () => {
      setLoading(true);
      try {
        let apiUrl = `${API_BASE_URL.replace(/\/$/, '')}/api/prayers?page=${currentPage}`;
        if (searchQuery && searchQuery.trim() !== '') {
          apiUrl += `&search=${encodeURIComponent(searchQuery)}`;
        }
        const response = await authFetch(apiUrl);
        if (!response.ok) throw new Error('Failed to fetch prayers');
        const result = await response.json();
        setData(result.data);
        setLastPage(result.last_page);
        setTotal(result.total);
      } catch (err) {
        setNotification({ show: true, message: 'Gagal memuat data doa: ' + err.message, type: 'error' });
      } finally {
        setLoading(false);
      }
    };
    fetchPrayers();
  }, [currentPage, searchQuery]);
  
  // Get user data for sidebar
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    setFormData({ category: 'doa harian', name: '', content: '' });
    setShowAddModal(true);
  };

  const handleSubmitAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await authFetch(`${API_BASE_URL.replace(/\/$/, '')}/api/prayers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Gagal menambah doa');
      }
      const newPrayer = await response.json();
      setData((prev) => [...prev, newPrayer]);
      setShowAddModal(false);
      setNotification({ show: true, message: 'Doa berhasil ditambahkan!', type: 'success' });
    } catch (err) {
      setNotification({ show: true, message: err.message, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleView = (prayer) => {
    setSelectedPrayer(prayer);
    setShowViewModal(true);
  };

  const handleEdit = (prayer) => {
    setSelectedPrayer(prayer);
    setFormData({ ...prayer });
    setShowEditModal(true);
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await authFetch(`${API_BASE_URL.replace(/\/$/, '')}/api/prayers/${selectedPrayer.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Gagal mengedit doa');
      }
      const updated = await response.json();
      setData((prev) => prev.map((item) => item.id === selectedPrayer.id ? updated : item));
      setNotification({ show: true, message: 'Doa berhasil diupdate!', type: 'success' });
      setShowEditModal(false);
    } catch (err) {
      setNotification({ show: true, message: err.message, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [prayerToDelete, setPrayerToDelete] = useState(null);

const handleDelete = (row) => {
  setPrayerToDelete(row);
  setShowDeleteModal(true);
};

const confirmDelete = async () => {
  if (!prayerToDelete) return;
  setLoading(true);
  try {
    const response = await authFetch(`${API_BASE_URL.replace(/\/$/, '')}/api/prayers/${prayerToDelete.id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Gagal menghapus doa');
    setData((prev) => prev.filter((item) => item.id !== prayerToDelete.id));
    setNotification({ show: true, message: 'Doa berhasil dihapus!', type: 'success' });
  } catch (err) {
    setNotification({ show: true, message: err.message, type: 'error' });
  } finally {
    setLoading(false);
    setShowDeleteModal(false);
    setPrayerToDelete(null);
  }
};

  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification({ ...notification, show: false });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);
  
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/').replace(/\/$/, '');
  const avatarUrl = user?.avatar_url
    ? user.avatar_url.startsWith('http')
      ? user.avatar_url
      : `${baseUrl}${user.avatar_url.startsWith('/') ? '' : '/'}${user.avatar_url}`
    : ''; 

  const adminData = {
    name: user?.name || '',
    position: user?.role || '',
    avatarUrl: avatarUrl,
  };

  return (
    <PageContainer>
      <PageHeader>
        <div>
          <h1>Daftar Doa</h1>
          <p>Kelola data doa-doa di sistem</p>
        </div>
      </PageHeader>
      
      <DashboardGrid>
        <AdminSidebar 
          user={adminData} 
          accordionState={accordionState} 
          setAccordionState={setAccordionState} 
        />
        <MainSection>
          <ActionHeader>
            <SearchContainer>
              <SearchInput
                type="text"
                placeholder="Cari doa"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </SearchContainer>
            <AddButton onClick={handleAdd}>+ Tambah Doa</AddButton>
          </ActionHeader>

      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>Kategori</th>
              <th>Nama Doa</th>
              
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4}>Memuat data doa...</td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan={4}>Tidak ada data doa.</td></tr>
            ) : (
              data.map((row) => (
                <tr key={row.id}>
                  <td>{row.category}</td>
                  <td>{row.name}</td>
                  
                  <td>
                    <Button onClick={() => handleView(row)} style={{ backgroundColor: '#2b5da1', marginRight: '0.5rem', padding: '0.5rem', width: 36, height: 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} title="Lihat">
  <ViewIcon />
</Button>
<Button onClick={() => handleEdit(row)} style={{ backgroundColor: '#2b5da1', marginRight: '0.5rem', padding: '0.5rem', width: 36, height: 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} title="Edit">
  <EditIcon />
</Button>
<DeleteButton onClick={() => handleDelete(row)} style={{ padding: '0.5rem', width: 36, height: 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} title="Hapus">
  <DeleteIcon />
</DeleteButton>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        <PaginationContainer>
          <PaginationInfo>
            Showing {data.length} of {total} entries
          </PaginationInfo>
          <PaginationButtons>
            <PaginationButton 
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
              disabled={currentPage === 1}
            >
              Previous
            </PaginationButton>
            <PageInfo>Page {currentPage} of {lastPage}</PageInfo>
            <PaginationButton 
              onClick={() => setCurrentPage(prev => prev < lastPage ? prev + 1 : prev)}
              disabled={currentPage === lastPage}
            >
              Next
            </PaginationButton>
          </PaginationButtons>
        </PaginationContainer>
      </TableContainer>
        </MainSection>
      </DashboardGrid>

      {/* Notification Toast */}
      {showViewModal && selectedPrayer && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <h2>Detail Obat</h2>
              <CloseButton onClick={() => setShowViewModal(false)}>&times;</CloseButton>
            </ModalHeader>
            <div>
              <FormGroup>
                <Label>Kategori</Label>
                <div>{selectedPrayer.category}</div>
              </FormGroup>
              <FormGroup>
                <Label>Nama Doa</Label>
                <div>{selectedPrayer.name}</div>
              </FormGroup>
              <FormGroup>
                <Label>Isi Doa</Label>
                <div style={{ whiteSpace: 'pre-line', background: '#f5f6fa', padding: '1rem', borderRadius: '0.5rem' }}>{selectedPrayer.content}</div>
              </FormGroup>
              <ButtonGroup>
                <CancelButton onClick={() => setShowViewModal(false)}>Tutup</CancelButton>
              </ButtonGroup>
            </div>
          </ModalContent>
        </Modal>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <h2>Konfirmasi Hapus</h2>
              <CloseButton onClick={() => setShowDeleteModal(false)}>&times;</CloseButton>
            </ModalHeader>
            <div>Apakah Anda yakin ingin menghapus doa ini?</div>
            <ButtonGroup style={{ marginTop: '2rem' }}>
              <CancelButton type="button" onClick={() => setShowDeleteModal(false)}>Batal</CancelButton>
              <DeleteButton type="button" onClick={confirmDelete}>Hapus</DeleteButton>
            </ButtonGroup>
          </ModalContent>
        </Modal>
      )}

      {/* Notification Toast */}
      {notification.show && (
        <NotificationToast $type={notification.type}>
          <NotificationMessage>{notification.message}</NotificationMessage>
          <CloseNotificationButton onClick={() => setNotification({ ...notification, show: false })}>
            ×
          </CloseNotificationButton>
        </NotificationToast>
      )}

      {/* Add Medicine Modal */}
      {showAddModal && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <h2>Tambah Doa</h2>
              <CloseButton onClick={() => setShowAddModal(false)}>&times;</CloseButton>
            </ModalHeader>
            <form onSubmit={handleSubmitAdd}>
  <FormGroup>
    <Label htmlFor="category">Kategori</Label>
    <Select
      id="category"
      name="category"
      value={formData.category}
      onChange={handleInputChange}
      required
    >
      <option value="doa harian">Doa Harian</option>
      <option value="doa malam">Doa Malam</option>
      <option value="doa tobat">Doa Tobat</option>
    </Select>
  </FormGroup>
  <FormGroup>
    <Label htmlFor="name">Nama Doa</Label>
    <Input
      id="name"
      name="name"
      type="text"
      value={formData.name}
      onChange={handleInputChange}
      required
    />
  </FormGroup>
  <FormGroup>
    <Label htmlFor="content">Isi Doa</Label>
    <Textarea
      id="content"
      name="content"
      value={formData.content}
      onChange={handleInputChange}
      required
    />
  </FormGroup>
  <ButtonGroup>
    <CancelButton type="button" onClick={() => setShowAddModal(false)}>
      Batal
    </CancelButton>
    <SubmitButton type="submit">
      Simpan
    </SubmitButton>
  </ButtonGroup>
</form>
          </ModalContent>
        </Modal>
      )}

      {/* Edit Medicine Modal */}
      {showEditModal && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <h2>Edit Doa</h2>
              <CloseButton onClick={() => setShowEditModal(false)}>&times;</CloseButton>
            </ModalHeader>
            <form onSubmit={handleSubmitEdit}>
              <FormGroup>
                <Label htmlFor="category">Kategori</Label>
                <Select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  <option value="doa harian">Doa Harian</option>
                  <option value="doa malam">Doa Malam</option>
                  <option value="doa tobat">Doa Tobat</option>
                </Select>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="name">Nama Doa</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="content">Isi Doa</Label>
                <Textarea
                  id="content"
                  name="content"
                  value={formData.content}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>
              <ButtonGroup>
                <CancelButton type="button" onClick={() => setShowEditModal(false)}>
                  Batal
                </CancelButton>
                <SubmitButton type="submit">
                  Simpan Perubahan
                </SubmitButton>
              </ButtonGroup>
            </form>
          </ModalContent>
        </Modal>
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 2rem;
  max-width: 1280px;
  margin: 0 auto;
  min-height: calc(100vh - 60px);
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;

  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  p {
    color: var(--text-light);
  }
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 1.5rem;
  
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  order: 2;
  @media (max-width: 1100px) {
    order: 1;
  }
`;

const ActionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const SearchContainer = styled.div`
  flex: 1;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  font-size: 1rem;


  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const TableContainer = styled.div`
  background-color: var(--background);
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border);
  }

  th {
    background-color: var(--background-light);
    font-weight: 600;
  }

  tbody tr:hover {
    background-color: var(--background-light);
  }
`;

const ActionButton = styled.button`
  background-color: ${props => props.$danger ? 'var(--error)' : 'var(--primary)'};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const AddButton = styled.button`
  background-color: #27ae60;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;

  &:hover {
    background-color: #219150;
    opacity: 0.95;
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: var(--background);
  border-radius: 0.5rem;
  padding: 1.5rem;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-light);
  
  &:hover {
    color: var(--text-dark);
  }
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  font-size: 1rem;
  background-color: #f5f6fa;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  font-size: 1rem;
  background-color: #f5f6fa;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  font-size: 1rem;
  min-height: 100px;
  resize: vertical;
  background-color: #f5f6fa;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const SubmitButton = styled(Button)`
  background-color: var(--primary);
  color: white;
  border: none;
`;

const CancelButton = styled(Button)`
  background-color: transparent;
  border: 1px solid var(--border);
  color: var(--text);
`;

const DeleteButton = styled.button`
  background-color: #e74c3c !important;
  color: #fff !important;
  font-weight: bold;
  border: 2px solid #c0392b;
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.15);
  letter-spacing: 0.5px;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  transition: opacity 0.2s, background-color 0.2s;
  &:hover, &:focus {
    background-color: #c0392b !important;
    outline: 2px solid #e74c3c;
    color: #fff !important;
    opacity: 0.95;
  }
`;


// Notification Toast Styles
const NotificationToast = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  min-width: 300px;
  background-color: ${props => props.$type === 'success' ? '#2ecc71' : '#e74c3c'};
  color: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  animation: slideIn 0.3s ease-out forwards;
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const NotificationMessage = styled.div`
  flex: 1;
  font-weight: 500;
`;

const CloseNotificationButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-left: 10px;
  opacity: 0.8;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 1;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const PaginationInfo = styled.div`
  color: #6c757d;
`;

const PaginationButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const PaginationButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid var(--border);
  background-color: white;
  color: var(--primary);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;

  &:hover:not(:disabled) {
    background-color: var(--primary);
    color: white;
    border-color: var(--primary);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #f5f6fa;
  }
`;

const PageInfo = styled.span`
  color: #6c757d;
`;

export default AdminDaftarDoaPage;